import { useEffect, useState } from "react";
import style from '../WallImage/style.module.css'
import useAxios from '../../../hooks/useAxios';

const UploadGroupImages = () => {
    const { AxiosPrivate } = useAxios()
    const [images, setImages] = useState([])
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState(0);
    const [totalSizeState, setTotalSizeState] = useState(0)

    useEffect(() => {
        window.addEventListener('click', handleRemove)
        return () => window.removeEventListener('click', handleRemove)
    }, [])

    function handleRemove(e) {
        if (e.target.id === 'upload_img') {
            const el = e.target.parentElement
            const file = el.getAttribute('data-file')
            setImages(prev => {
                if (file) {
                    const deletedImage = prev.find(i => i.name === file)
                    return prev.filter(i => i !== deletedImage)
                }
            })
            el.remove();
        }
    }

    const handleMultipleImage = (e) => {
        const imgArray = [];
        const fileArry = e.target.parentElement.parentElement.parentElement.children[1]
        let totalSize = 0; // Initialize a variable to hold the total size

        if (e.target.files.length > 20) {
            alert('حداکثر تعداد 20 عکس مجاز است')
            return
        }
        for (const file of e.target.files) {
            imgArray.push(file);
            totalSize += file.size; // Add the size of each file to the totalSize

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener('load', function () {
                let html = `
                <div className=${style.upload__img_box} data-file='${file.name}' >
                    <img src='${this.result}' />
                    <div className=${style.upload__img_close} id='upload_img'></div>
                </div>`;
                fileArry.innerHTML += html
            })
        }
        const totalSizeInMB = totalSize / (1024 * 1024);
        setTotalSizeState(totalSizeInMB.toFixed(2))

        setImages(prev => {
            return [
                ...prev,
                ...imgArray
            ]
        })
    }

    const handleSubmit = async () => {
        if (totalSizeState > 120) {
            alert('حداکثر تا 120 مگابایت مجاز است')
            return
        }
        await AxiosPrivate.post(`painting/upload`, { images }, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgress(percentCompleted);
                setLoading(true)
            },
        })
            .then(res => {
                setProgress(100);
                alert(res.data.message);
                window.location.reload()
                setLoading(false)
            })
            .catch(err => {
                alert(err.response?.data.message || 'مشکلی پیش آمده');
                setLoading(false)
                setProgress(0);
            })
            .finally(() => setProgress(0))
    }

    return (
        <>
            <div className={style.iJIucw}>
                <div className={style.upload__btn_box}>
                    <label dir="auto" className="text-white cursor-pointer w-64 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                                        focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-2 py-2.5 text-center" htmlFor="inputFiles">
                        <p>آپلود تصاویر جدید</p>
                        <input onChange={handleMultipleImage}
                            type="file" name="image" id="inputFiles"
                            hidden multiple
                            accept='image/jpeg, image/jpg, image/png, image/webp' />
                    </label>
                </div>
                <div className={style.upload__img_wrap}> </div>
                {!!images.length && <button onClick={handleSubmit} type="button" className="text-white w-32 bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center m-4">{loading ?
                    <div role="status">
                        <svg stroke="currentColor" aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin fill-gray-50" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"></path></svg>
                        <span className="sr-only">Loading...</span>
                    </div>
                    : 'ثبت'}</button>}
                {progress > 0 &&
                    <div className="w-full bg-gray-200 rounded-full dark:bg-gray-700 overflow-hidden">
                        <div className="bg-gradient-to-r from-blue-400 via-blue-600 to-blue-700 text-xs font-medium text-blue-100 text-center py-1.5 leading-none duration-300 rounded-full whitespace-nowrap" style={{ width: `${progress}%` }}>{progress}%</div>
                    </div>}

            </div>
        </>
    );
};

export default UploadGroupImages;